import { buySuccessType, priceType } from "../purchase/purchaseTypes";
import { actionTypes } from "./contactsTypes";


export const initialState: contactsReducerType = {
  restContacts: 0,
  contactsPriceList: [],
  showContactMessage: false,
  messageStatus: null,
  messageTrigger: false,
  buyLoading: false,
  buySuccess: "Never"
};

type contactsReducerType = {
  restContacts: number;
  contactsPriceList: priceType[];
  showContactMessage: boolean;
  messageStatus: number | null;
  messageTrigger: boolean,
  buyLoading: boolean;
  buySuccess: buySuccessType;
};

const contactsReducer = (state = initialState, { type, payload }: any): contactsReducerType => {
  switch (type) {
    case actionTypes.SET_REST_CONTACTS:
      return {
        ...state,
        restContacts: payload
      }
    case actionTypes.TOGGLE_CONTACT_MESSAGE:
      return {
        ...state,
        showContactMessage: payload
      }
    case actionTypes.SET_MESSAGE_STATUS:
      return {
        ...state,
        messageStatus: payload
      }
    case actionTypes.SET_MESSAGE_TRIGGER:
      return {
        ...state,
        messageTrigger: payload
      }
    case actionTypes.SET_CONTACTS_PRICELIST:
      return {
        ...state,
        contactsPriceList: payload
      }
    case actionTypes.SET_BUY_LOADING:
      return {
        ...state,
        buyLoading: payload,
      };
    case actionTypes.SET_BUY_SUCCESS:
      return {
        ...state,
        buySuccess: payload,
      };
    default:
      return state;
  }
};

export default contactsReducer;
